import { render, staticRenderFns } from "./lightbox-settings-search.vue?vue&type=template&id=564bc2a3&scoped=true&"
import script from "./lightbox-settings-search.vue?vue&type=script&lang=js&"
export * from "./lightbox-settings-search.vue?vue&type=script&lang=js&"
import style0 from "./lightbox-settings-search.vue?vue&type=style&index=0&id=564bc2a3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564bc2a3",
  null
  
)

export default component.exports